export default __webpack_public_path__ + "static/media/home__offer.c2d3f62e.jpg";